<template>
  <div class="test-room-container">
    <div class="test-room-box">
      <div class="block">
        <h1 class="subtitle has-text-secondary">
          {{translate('RateTestCall')}}
        </h1>

        <section class ="rating">
          <b-rate
              icon-pack="fas"
              v-model="rate"
              :disabled="rated"
              ></b-rate>
        </section>

        <b-button id="btn-login"
                  ref="btn-login"
                  type="is-primary"
                  size="is-medium"
                  :disabled="loading"
                  expanded
                  @click="review">
          {{translate('Submit')}}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import BackendService from "@/service/backendService";
import {lang} from "@/lang";

export default {
  name: "TestRoomGuard",
  props: {
    isTranslated: Boolean,
  },
  data() {
    return {
      loading: false,
      rate: 1,
      uuid: null,
      rated: false
    }
  },
  methods: {
    review() {
      this.loading = true;

      BackendService.reviewTestRoom(this.uuid, this.rate)
          .then(() => {
            this.$buefy.toast.open({
              message: this.translate('RateSuccessful'),
              type: 'is-success'
            })
          })
          .catch(() => {
                this.$buefy.toast.open({
                  message: this.translate('RateFailed'),
                  type: "is-danger",
                  duration: 5000
                })
                this.loading = false;
              }
          );

      this.rated = true;
    },
    translate(property) {
      return this.$props.isTranslated ? lang['en'][property] : lang['hu'][property]
    },
  },

  mounted() {
      this.uuid = this.$route.params.uuid;
  }
}
</script>

<style scoped>
.test-room-container h1 {
  text-align: center;
}
</style>